/**
 * @name windows.constants
 * @description Core windows.constants in ngx-responsive
 *
 * @license MIT
 */
import { IWindowsOS } from '../interfaces';

export const WINDOWS_OS: IWindowsOS = {
    WINDOWS_XP: 'Windows XP',
    WINDOWS_VISTA: 'Windows Vista',
    WINDOWS_7: 'Windows 7',
    WINDOWS_8: 'Windows 8',
    WINDOWS_10: 'Windows 10',
    GENERIC_WINDOWS: 'Generic Windows'
};
